'use client';
import { getUrlGtm } from '@/utils/gtmUtils';
import GloLayout from 'code-micro/common/GloLayoutA';
import { ContentServerProps } from 'code-micro/props/content';
import getLocal from 'eco-design-reliance/getLocal';
import EcoImg from 'eco-design/base/eco-img';
import EcoLink from 'eco-design/base/eco-link';
import { useEffect, useState } from 'react';
import './index.scss';

export default function Content({ id, data = {} }: ContentServerProps) {
    const { locale = 'us' } = getLocal();
    const { title, desc, bgColor, list = [] } = data;

    const [curIndex, setCurIndex] = useState(0);
    useEffect(() => {
        if (typeof window === 'undefined') return;
        const all = document.querySelectorAll('.editor-index-list-d1');
        const current = document.querySelector(`.editor-${id}`);
        if (all?.length > 0 && current) {
            all?.forEach?.((item, idx) => {
                if (item === current) {
                    setCurIndex(idx + 1);
                }
            });
        }
    }, [id]);

    return (
        <GloLayout
            className={`editor-index-list-d1 length-${list?.length}`}
            id={id}
            data={data}
            isFixedWidthCenterV2={true}
            floorName="index-list-d1"
            style={bgColor ? { background: bgColor } : {}}
        >
            <h2 className="index-list-d1-title">{title}</h2>
            <p className="index-list-d1-desc">{desc}</p>
            <div className={`index-list-d1-list list-${list.length}`}>
                {list?.map((itemA: any, index1: number) => {
                    if (!itemA) {
                        return null;
                    }
                    return (
                        <EcoLink
                            className={`index-list-d1-item GtmModuleData-btn-href cjfwyzc-item-${index1}`}
                            key={index1}
                            href={itemA.href}
                            dataLayer={{
                                ...getUrlGtm(itemA.href, locale, {
                                    list_name: title,
                                    button_name: itemA.title,
                                    product_name: itemA.title,
                                }),
                                position: `Homepage_SceneSupport_${curIndex}_${index1 + 1}`,

                                __btn_id1: `editor-${id} .cjfwyzc-item-${index1}`,
                                __btn_id2: itemA.href,
                                __btn_type: 'href',
                            }}
                        >
                            <EcoImg pc={itemA.pc} h5={itemA.h5} />
                            <div className="index-list-d1-item-msg">
                                <div className="index-list-d1-item-title" style={{ color: itemA.titleColor }}>
                                    {itemA.title}
                                    <svg
                                        className="index-list-d1-item-arrow"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                    >
                                        <path d="M9 6L15 12L9 18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                            </div>
                        </EcoLink>
                    );
                })}
            </div>
        </GloLayout>
    );
}
